/**
 * Business-Friendly Deployment Messages
 * Single logical progression without repetition or confusion
 */

/**
 * Deployment Progress Messages - Clear, sequential steps that business users understand
 */
export const DeploymentProgressMessages = {
  SETTING_UP_DOMAIN: 'Setting up domain and infrastructure...',
  UPLOADING_CONTENT: 'Uploading website content...',
  CONFIGURING_WEBSITE: 'Configuring website settings...',
  SYNCING_INFRASTRUCTURE: 'Syncing infrastructure with ArgoCD...',  // NEW: ArgoCD sync step
  RUNNING_TESTS: 'Running tests to ensure everything works perfectly...',
  TAKING_LONGER: 'This is taking a bit longer than usual - probably just extra thorough testing!',
  ALMOST_READY: 'Almost there! Your website should be live any moment now...',
  FINALIZING: 'Almost ready! Your website should be live any moment now...',
  WEBSITE_READY: 'Your website is ready!'
} as const;

/**
 * Website Accessibility Check Messages - For post-deployment polling
 */
export enum AccessibilityCheckMessages {
  INITIAL_CHECK = 'Website deployed! Checking accessibility...',
  STILL_CHECKING = 'Still verifying your website is fully accessible...',
  EXTENDED_CHECK = 'Taking longer than expected - ensuring everything is working properly...',
  FINAL_VERIFICATION = 'Performing final accessibility verification...'
}

/**
 * Deployment Status Messages - Only used when we can't determine specific progress
 */
export enum DeploymentStatusMessages {
  PROCESSING = 'Working on your website...',
  DEPLOYING = 'Making your website live...',
  VERIFYING = 'Running final checks...',
  DONE = 'Your website is live!',
  FAILED = 'We encountered an issue',
  DEFAULT = 'Processing your request...'
}

/**
 * Deployment Status Emojis - Visual indicators
 */
export enum DeploymentStatusEmojis {
  PROCESSING = '⚙️',
  DEPLOYING = '🚀',
  VERIFYING = '🔍',
  DONE = '🎉',
  FAILED = '❌',
  DEFAULT = '🔄'
}

/**
 * Deployment Success Messages - Single consolidated success message
 */
export enum DeploymentSuccessMessages {
  WEBSITE_COMPLETE = '🎉 Congratulations! Your website is now live and ready for customers: <a href="{url}" target="_blank">{url}</a><br><br>💾 Save this link - it\'s your permanent website address that you can share with customers to start getting quotes!',
  WEBSITE_READY = '✅ Your professional website is ready for business!'
} 